import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Component from '../../../components/Production/pending/BlockInspectionStatusMasterlist'

const BlockInspectionStatusMasterlist = () => {
    return (
        <Layout
            title={'Block Inspection Status'}
        >
            <Component />


        </Layout>
    )
}

export default BlockInspectionStatusMasterlist